<script>
import RawData from '@/components/widgets/raw-data.vue'
export default{
    name: 'service-map',
    components: {
        RawData
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        loading: Boolean
    },
    data(){
        return{
            selectedServiceMap: {
                id: 0,
                deliveryUnitServiceFees: [],
                subscribers: [],
                menuSelection: 0,
                loadingServiceMap: false,
                loadingSubscribers: false,
            },
            gridSize: { rows: 0, cols: 0 },
            boxPositions: new Map(),
        }
    },
    computed: {
        addBoxPlaceholders() {
            const placeholders = [];
            this.items.forEach(box => {
                if (box.right === null) {
                    placeholders.push({
                        key: `right-${box.id}`,
                        sourceBox: box,
                        direction: 'right'
                    });
                }
                if (box.bottom === null) {
                    placeholders.push({
                        key: `bottom-${box.id}`,
                        sourceBox: box,
                        direction: 'bottom'
                    });
                }
            });
            return this.filterOverlappingPlaceholders(placeholders);
        }
    },
    methods:{
        addSubscriber(row){
            this.$emit('add-subscriber', row)
        },
        editServiceMap(row){
            this.$emit('edit-service-map', row)
        },
        deleteServiceMap(box){
            this.$emit('delete-service-map', box);
            
            // const boxId = box.id;
            
            // // Update references from other boxes
            // this.items.forEach(item => {
            //     // If a box has this box as right reference
            //     if (item.right === boxId) {
            //     // If the box being deleted has a right box, connect them
            //         const rightBox = this.items.find(b => b.id === box.right);
            //         item.right = rightBox ? rightBox.id : null;
            //     }
                
            //     // If a box has this box as bottom reference
            //     if (item.bottom === boxId) {
            //         // If the box being deleted has a bottom box, connect them
            //         const bottomBox = this.items.find(b => b.id === box.bottom);
            //         item.bottom = bottomBox ? bottomBox.id : null;
            //     }
                
            //     // If a box has this box as top reference
            //     if (item.top === boxId) {
            //     // Set top to the box's top (moving up one level)
            //         item.top = box.top;
            //     }
                
            //     // If a box has this box as left reference
            //     if (item.left === boxId) {
            //         // Set left to the box's left (moving left one level)
            //         item.left = box.left;
            //     }
            // });
            
            // // Remove the box from the items array
            // const boxIndex = this.items.findIndex(item => item.id === boxId);
            // if (boxIndex !== -1) {
            //     this.items.splice(boxIndex, 1);
            // }
            
            // // Recalculate the grid after deletion
            // this.calculateGridSize();
        },
        calculateGridSize() {
            // Calculate the maximum grid dimensions needed
            let maxRow = 0;
            let maxCol = 0;
            
            // Build a position map for the boxes
            this.boxPositions.clear();
            this.items.forEach(box => {
                // Use the explicit coordinates from the data
                const row = this.getRowPosition(box);
                const col = this.getColPosition(box);
                
                this.boxPositions.set(box.id, { row, col });
                
                maxRow = Math.max(maxRow, row);
                maxCol = Math.max(maxCol, col);
            });
            
            this.gridSize = { 
                rows: maxRow + 2, // Add extra space for potential placeholders
                cols: maxCol + 2
            };
        },
        
        getRowPosition(box) {
            // If box references a parent via 'top', get that parent's row + 1
            if (box.top !== null && box.top !== undefined) {
                const parentBox = this.items.find(item => item.id === box.top);
                if (parentBox) {
                    return this.getRowPosition(parentBox) + 1;
                }
            }
            return 0; // Default row if no top reference
        },
        
        getColPosition(box) {
            // If box references a box to its left, get that box's column + 1
            if (box.left !== null && box.left !== undefined && box.left !== 0) {
                const leftBox = this.items.find(item => item.id === box.left);
                if (leftBox) {
                    return this.getColPosition(leftBox) + 1;
                }
            }
            return box.left || 0; // Use the explicit left value or default to 0
        },
        
        getBoxPosition(box) {
            this.calculateGridSize(); // Recalculate positions
            
            const position = this.boxPositions.get(box.id);
            if (!position) return {};
            
            return {
                gridRow: `${position.row + 1}`,
                gridColumn: `${position.col + 1}`
            };
        },
        
        getPlaceholderPosition(placeholder) {
            const sourcePosition = this.boxPositions.get(placeholder.sourceBox.id);
            if (!sourcePosition) return {};
            
            if (placeholder.direction === 'right') {
                return {
                    gridRow: `${sourcePosition.row + 1}`,
                    gridColumn: `${sourcePosition.col + 2}`
                };
            } else if (placeholder.direction === 'bottom') {
                return {
                    gridRow: `${sourcePosition.row + 2}`,
                    gridColumn: `${sourcePosition.col + 1}`
                };
            }
            
            return {};
        },
        
        filterOverlappingPlaceholders(placeholders) {
            // Check for placeholders that would overlap with existing boxes
            return placeholders.filter(placeholder => {
                const position = this.getPlaceholderPosition(placeholder);
                const row = parseInt(position.gridRow);
                const col = parseInt(position.gridColumn);
                
                // Check if any box exists at this position
                return !Array.from(this.boxPositions.values()).some(
                    pos => pos.row + 1 === row && pos.col + 1 === col
                );
            });
        },
        addNewMap(placeholder) {
            this.$emit('add-service-map', placeholder);
        },
        addServiceMap(placeholder) {
            if (!placeholder) return;
            const newBox = {
                id: Math.max(...this.items.map(item => item.id), 0) + 1,
                name: `Service Map ${this.items.length + 1}`,
                description: `Service Map ${this.items.length + 1} Description`,
                right: null,
                bottom: null
            };
            
            const sourceBox = placeholder.sourceBox;
            
            if (placeholder.direction === 'right') {
                // Position to the right of source box
                newBox.top = sourceBox.top;
                newBox.left = sourceBox.id;
                
                // Update the source box to reference this new box
                const sourceBoxIndex = this.items.findIndex(item => item.id === sourceBox.id);
                if (sourceBoxIndex !== -1) {
                    this.items[sourceBoxIndex].right = newBox.id;
                }
            } else if (placeholder.direction === 'bottom') {
                // Position below the source box
                newBox.top = sourceBox.id;
                newBox.left = sourceBox.left;
                
                // Update the source box to reference this new box
                const sourceBoxIndex = this.items.findIndex(item => item.id === sourceBox.id);
                if (sourceBoxIndex !== -1) {
                    this.items[sourceBoxIndex].bottom = newBox.id;
                }
            }
            
            this.items.push(newBox);
            this.calculateGridSize();
        },
    },
    mounted() {
        this.calculateGridSize();
    },
}
</script>
<template>
<div class="overflow-auto">
  <div class="service-map-container">
    <div class="service-map-box add-box-placeholder" v-if="!items.length" @click="addNewMap(null)">
        <div class="add-box-content" >
            <span class="add-icon">+</span>
            <span>Add Location</span>
        </div>
    </div>
    <div 
      v-for="item in items" 
      :key="item.id"
      class="service-map-box"
      :style="getBoxPosition(item)"
    >
        <RawData :data="item" v-if="$store.state.decrypt.isAdmin()"/>
        <div class="box-header">{{ item.name }}</div>
        <div class="box-body">{{ item.description }}</div>
        <div class="box-actions">
            <button class="edit-btn" @click="addSubscriber(item)">Add Subscriber</button>
            <button class="edit-btn" @click="editServiceMap(item)">Edit</button>
            <button class="delete-btn" @click="deleteServiceMap(item)">Delete</button>
        </div>
    </div>
    
    <!-- Add Box placeholders -->
    <div 
      v-for="placeholder in addBoxPlaceholders" 
      :key="placeholder.key"
      class="service-map-box add-box-placeholder"
      :style="getPlaceholderPosition(placeholder)"
      @click="addNewMap(placeholder)"
    >
      <div class="add-box-content">
        <span class="add-icon">+</span>
        <span>Add Location</span>
      </div>
    </div>
  </div>
</div>
</template>
<style lang="scss">
.service-map-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, 250px);
  grid-auto-rows: minmax(120px, auto);
  grid-gap: 15px;
  padding: 20px;
  position: relative;
  min-height: 300px;
}

.service-map-box {
    width: 250px; /* Fixed width */
    height: 180px; /* Fixed height */
    min-width: 250px; /* Enforce minimum width */
    min-height: 180px; /* Enforce minimum height */
    max-width: 250px; /* Enforce maximum width */
    max-height: 180px;    /* Fixed height */
    border-radius: 4px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    background: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: all 0.2s ease;
    overflow: auto; 
    position: relative;
    
    &:hover {
        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    }
}

.box-header {
    font-weight: bold;
    margin-bottom: 10px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
}

.box-body {
    font-size: 14px;
    flex-grow: 1;
    color: #555;
}

.box-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 15px;
    
    button {
        padding: 4px 8px;
        border-radius: 3px;
        border: none;
        cursor: pointer;
        font-size: 12px;
        
        &.edit-btn {
            background-color: #f0f0f0;
            color: #333;
        }
        
        &.delete-btn {
            background-color: #ffebee;
            color: #f44336;
        }
        
        &:hover {
            opacity: 0.8;
        }
    }
}

.add-box-placeholder {
  border: 2px dashed #ccc;
  background-color: transparent !important;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #2196f3;
  transition: all 0.2s;
  
  &:hover {
    border-color: #2196f3;
    color: #2196f3;
    background-color: rgba(33, 150, 243, 0.05);
  }
  
  .add-box-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .add-icon {
      font-size: 24px;
      margin-bottom: 5px;
    }
  }
}
</style>